import { BetQLSportItem } from "./";
import { DEFAULT_TREND_TYPES } from "./configs";

const NFLConfig: BetQLSportItem = {
  id: "b8245e1a-1086-44e6-b84f-26fc8c254ef7",
  name: "NFL",
  url: "nfl",
  tabName: "NFL",
  icon: "football",
  imagePath: "NFL",
  key: "NFL",
  lookupKey: "nfl",
  favoriteLine: "spread",
  hasTeamPowerProjectionGrades: true,
  hasFGspreadPowerRating: true,
  hasFGmoneylinePowerRating: true,
  hasFGtotalPowerRating: true,
  has1HspreadPowerRating: true,
  has1HmoneylinePowerRating: true,
  has1HtotalPowerRating: true,
  has1PspreadPowerRating: false,
  has1PmoneylinePowerRating: false,
  has1PtotalPowerRating: false,
  hasPitchers: false,
  hasGoals: false,
  hasInjuries: true,
  hasNews: false,
  hasLineup: true,
  hasSchedule: true,
  hasConfiguredSchedule: true,
  hasTeamSummary: true,
  hasGameFilters: true,
  hasStadium: true,
  hasLocation: true,
  hasTeamRecord: true,
  hasApRank: false,
  hasConferenceDropdown: false,
  hasNewsInjuriesColumn: true,
  hasDraws: false,
  hasSharpData: true,
  hasTopTrendsData: false,
  hasPlayerProps: true,
  hasRecommendedBets: true,
  hasPopularEvents: true,
  isCollege: false,
  defaultUserSetting: '{"name": "Default Setting", "columnOrder": [2,5,9,15,4]}',
  defaultColumnOrder: [2, 5, 9, 15, 4],
  publicThreshold: 60,
  sharpPercentThreshold: 20,
  sharpCountThreshold: 500,
  publicCountThreshold: 500,
  trendTypes: DEFAULT_TREND_TYPES,
  filters: [
    {
      name: "Spread",
      key: "spread",
      url: "spread",
    },
    {
      name: "Moneyline",
      key: "moneyline",
      url: "moneyline",
    },
    {
      name: "Total",
      key: "total",
      url: "totals-spread",
    },
    {
      name: "1st Half Spread",
      key: "1Hspread",
      url: "first-half-lines",
    },
    {
      name: "1st Half Moneyline",
      key: "1Hmoneyline",
      url: "first-half-moneyline",
    },
    {
      name: "1st Half Total",
      key: "1Htotal",
      url: "first-half-totals-spread",
    },
    {
      name: "2nd Half Spread",
      key: "2Hspread",
      url: "second-half-lines",
    },
    {
      name: "2nd Half Moneyline",
      key: "2Hmoneyline",
      url: "second-half-moneylines",
    },
  ],
  periods: ["FULLGAME", "FIRSTHALF", "SECONDHALF"],
  periodKeys: ["FG", "1H", "2H"],
  pickTypes: ["spread", "moneyline", "total", "1Hspread", "1Hmoneyline", "1Htotal", "2Hspread", "2Hmoneyline"],
};

export default NFLConfig;
